module.exports = __webpack_public_path__ + "img/scroll-indicator-dark.9a608eb.svg";